// replace visible nbsp in templates

export const resolveNbsp = (str: string) => {
  return str.replace(/\&nbsp;/g, "\u00A0");
};
